__turbopack_context__.v({
  "devTools": "DevTools-module__lmNr7a__devTools",
  "devToolsPanel": "DevTools-module__lmNr7a__devToolsPanel",
});
